export class EntityDoesNotExistException extends Error {
  constructor(message) {
    super(message);
  }
}

